import { useQuery } from "react-query";

import axios from "axios";

import { GEO_MAP_SERVICE_ADDRESS } from "../../../constants/app.constants";
import {
  MapDataKind,
  MapLayerDataResponse
} from "../GeoMapDataTable/GeoMapDataTableWidget.types";

export const MAP_LAYER_DATA_QUERY_KEY = "mapLayerData";

const fetchMapLayerData = async (
  layerIds: number[],
  kind: MapDataKind,
  limit: number,
  page: number
): Promise<MapLayerDataResponse> => {
  const primaryId = layerIds[0];
  const params: Record<string, string | number> = { kind, limit, page };
  if (layerIds.length > 1) {
    params.layer_ids = layerIds.join(",");
  }
  const response = await axios.get<MapLayerDataResponse>(
    `${GEO_MAP_SERVICE_ADDRESS}/map-layer/${primaryId}/data`,
    { params }
  );
  return response.data;
};

const useMapLayerData = (
  layerIds: number[],
  kind: MapDataKind,
  limit: number,
  page: number
) => {
  return useQuery<MapLayerDataResponse>(
    [MAP_LAYER_DATA_QUERY_KEY, layerIds, kind, limit, page],
    () => fetchMapLayerData(layerIds, kind, limit, page),
    {
      enabled: layerIds.length > 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false
    }
  );
};

export default useMapLayerData;
